import { cva, type VariantProps } from 'class-variance-authority'
import { Check, Clock, Info, TriangleAlert, type LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import { cn } from '../../lib/utils'

/** Pastille de statut : la couleur ne porte jamais seule le sens (icône + libellé). Le jaune de marque n'est jamais un statut. */
const variantesBadge = cva('inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-sm font-semibold [&_svg]:size-4 [&_svg]:shrink-0', {
  variants: {
    statut: {
      succes: 'bg-green-100 text-green-900',
      info: 'bg-blue-100 text-blue-900',
      danger: 'bg-red-100 text-red-900',
      neutre: 'bg-slate-200 text-slate-900',
    },
  },
  defaultVariants: { statut: 'neutre' },
})

const ICONES: Record<NonNullable<VariantProps<typeof variantesBadge>['statut']>, LucideIcon> = {
  succes: Check,
  info: Info,
  danger: TriangleAlert,
  neutre: Clock,
}

export function Badge({ statut = 'neutre', className, children }: VariantProps<typeof variantesBadge> & { className?: string; children: ReactNode }) {
  const Icone = ICONES[statut ?? 'neutre']
  return (
    <span className={cn(variantesBadge({ statut }), className)}>
      <Icone aria-hidden />
      {children}
    </span>
  )
}
